import React from "react";

const InstaShop = () => {
  return (
    <div className="overflow-hidden relative">
      <div className="mt-10 flex flex-col items-center w-[100vw]">
        
        {/* ✅ SEO-friendly Heading */}
        <h6 className="text-2xl text-center font-bold">
          Clariss Food Instashop
        </h6>
        <p className="text-xl text-center mt-6 text-accent font-bold">
          Follow Us on Instagram for Healthy Living Inspiration
        </p>

        {/* ✅ Instagram Feed Section */}
        <div className="grid grid-cols-2 sm:flex sm:flex-row justify-center items-center mt-10 sm:mx-0">
          
          {/* Instagram Post 1 – Sunflower Oil */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post about sunflower oil"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src="https://i.ibb.co/66dLMqv/475462891-595209763428316-1487609484882002537-n.jpg"
                alt="Clariss Fortified Sunflower Oil – Healthy cooking essentials"
                title="Clariss Healthy Sunflower Oil Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 2 – Olive Oil */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post about olive oil"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src="https://i.ibb.co/Fqfvmcrw/481765261-618525134430112-810580105209236204-n-1.jpg"
                alt="Clariss Olive Oil – Premium extra virgin olive oil for wellness"
                title="Clariss Olive Oil Healthy Living Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 3 – Organic Honey */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post about organic honey"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src="https://i.ibb.co/1JjGRJdM/481468608-616734544609171-6028494844331718423-n-1.jpg"
                alt="Clariss Organic Honey – Pure natural sweetness for a healthy lifestyle"
                title="Clariss Organic Honey Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 4 – Cooking Oils */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post about healthy cooking oils"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125"
                src="https://i.ibb.co/1Jryj4T6/481465065-616734757942483-6625467428761279381-n-1.jpg"
                alt="Clariss Healthy Cooking Oils – Fortified and natural oils"
                title="Clariss Healthy Cooking Oils Post"
                loading="lazy"
              />
            </a>
          </div>

          {/* Instagram Post 5 – Healthy Lifestyle */}
          <div className="overflow-hidden">
            <a
              href="https://www.instagram.com/clarissbangladesh/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Clariss Bangladesh Instagram Post about healthy lifestyle"
            >
              <img
                className="w-[400px] ease-in-out duration-200 hover:scale-125 hidden sm:block"
                src="https://i.ibb.co/8kfX3P5/479557651-603637845918841-4816207490405048112-n.jpg"
                alt="Clariss Healthy Living – Natural and organic food essentials"
                title="Clariss Healthy Living Inspiration"
                loading="lazy"
              />
            </a>
          </div>
        </div>

        {/* ✅ Optional CTA for Instagram */}
        {/* <p className="text-center mt-6 font-bold">
          <a
            href="https://www.instagram.com/clarissbangladesh/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent hover:underline"
          >
            👉 Follow @ClarissBangladesh on Instagram for more healthy food tips!
          </a>
        </p> */}
      </div>
    </div>
  );
};

export default InstaShop;
